<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                Gestion des demandes de paiements
                                <v-spacer></v-spacer>
                               <!-- <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>-->
                            </v-card-title>
                            <div class="row">
                                <div class="col-12 mb-4">

                                    <v-tabs v-model="tabs" color="#1C3071" grow >
                                        <v-tab>
                                            En attente
                                        </v-tab>
                                        <v-tab>
                                            Effectué
                                        </v-tab>
                                        <v-tab>
                                            Annuler / Refusé
                                        </v-tab>
                                    </v-tabs>

                                    <v-tabs-items v-model="tabs">
                                        <!--En attente-->
                                        <v-tab-item>
                                            <v-card flat>
                                                <EnAttente></EnAttente>
                                            </v-card>
                                        </v-tab-item>
                                        <!--Demande Effectuer-->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <Effectuer></Effectuer>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--Demande Annuler-->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <Annuler></Annuler>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>


                                    </v-tabs-items>

                                </div>
                            </div>
                           <!-- <v-data-table
                                    :headers="headers"
                                    :items="ask_payouts"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                     loading-text="Chargement en cours...">

                                <template v-slot:item.montant="{ item }">
                                    <v-chip  dark>{{ item.montant +" FCFA" }}</v-chip>
                                </template>
                                <template v-slot:item.ask_time="{item}">
                                    {{ getformatDate(item.ask_time)}}
                                </template>
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="500px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouvelle demande
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>
                                                            <div class="row" >
                                                                <div class="col-md-6">
                                                                    <v-text-field
                                                                            clearable :rules="montantRules" v-model="editedItem.montant"
                                                                            label="Montant" placeholder="ex : 50.000 >=10.000" type="number"></v-text-field>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <v-text-field
                                                                            clearable :rules="phoneRules" v-model="editedItem.phone_receiver"
                                                                            label="Numéro de retrait" placeholder="ex : +22996660000" type="number"></v-text-field>
                                                                </div>

                                                            </div>

                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field style="height: 30px"
                                                                        clearable :rules="commentRules" v-model="editedItem.comment"
                                                                        label="Commentaire" placeholder="ex :  At vero eos et accusam et justo duo dolores ">
                                                                </v-text-field>
                                                            </v-col>


                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template  v-slot:item.actions="{ item }">
                                    <div v-if='item.state_ask==="Demande refusée"'>
                                        <v-chip color="red" dark>Refusée</v-chip>

                                    </div>
                                    <div v-else-if='item.state_ask==="Retrait éffectué"'>
                                        <v-chip color="green" dark>Approuvée</v-chip>
                                    </div>
                                    <div v-else-if=' item.state_ask==="Demande confirmée, en attente de paiement"'>
                                        <v-chip color="#FFCC00" dark>En attende de paiement</v-chip>

                                    </div>
                                    <div v-else-if=' item.state_ask==="Annuler"'>

                                        <v-chip  color="#bb0b0b" dark>Annuler</v-chip>

                                    </div>
                                    <div v-else>

                                        <v-chip v-if="item.pharmacie_user_slug !==user._id"  color="#ccc" dark>En attente</v-chip>
                                        <v-btn v-else style="color: #fff" class="btn btn-danger" @click="deleteItem(item)" color="#bb0b0b">Annuler</v-btn>

                                    </div>

                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>-->
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import EnAttente from "./DemandePaiement/EnAttente";
    import Effectuer from "./DemandePaiement/Effectuer";
    import Annuler from "./DemandePaiement/Annuler";
    export default {
        name: "AskPayout",
        components: {Annuler, Effectuer, EnAttente},
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                tabs: null,
                dialog: '',
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                id: undefined,
                snackbar: false,
                textSnack: '',
                headers: [
                    {text: 'Commentaire', value: 'comment'},

                    {
                        text: 'Montant',
                        align: 'start',
                        sortable: true,
                        value: 'montant',
                    },
                    {text: 'Numéro de retrait', value: 'phone_receiver'},
                    {text: 'Etat', value: 'state_ask'},
                    {text: 'Avis admin', value: 'comment_ask_admin'},
                    {text: 'Date de demande', value: 'ask_time'},

                    {text: 'Actions', value: 'actions', sortable: false},


                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                commentRules: [
                    v => !!v || 'Comment requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                montantRules: [
                    v => !!v || 'Montant requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                phoneRules: [
                    v => !!v || 'Numéro de retrait  requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],



            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle demande" : "Mise à jour"
            }
            ,
            ...mapState('ask_payouts/', ['ask_payouts']),
            ...mapState('balance/', ['balance'])


        }
        ,
        mounted() {
        window.scrollTo(0,0);
            if (this.user.type_compte == "pharmacie")
            {
                if (!this.roles.includes("DP")){
                    this.$router.push("permission");
                }
            }
            let user = JSON.parse(localStorage.getItem("user"));
            console.log("User local2");
            console.log(user);
            this.$store.dispatch('ask_payouts/getAsk_payoutOne',user.relation._id).then(response => {
                window.console.log('ask_payouts', response)
            });
            this.$store.dispatch('balance/get',user.relation._id).then(response => {
                window.console.log('user', response)
            });


        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.ask_payouts.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },

            deleteItem(item) {
                    Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir anuuler cette demande ?",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('ask_payouts/annuleAsk_payout', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            });
                            let user=JSON.parse(localStorage.getItem("user"));
                            this.$store.dispatch('ask_payouts/getAsk_payoutOne',user.relation._id).then(response => {
                                window.console.log('ask_payouts', response)
                            });
                        })
                    }
                })
            },
            close() {
                this.$refs.form.reset()
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.dialog = false;

            },
            save() {
                this.submitting = true;
                let user=JSON.parse(localStorage.getItem("user"));
                let data = new FormData();
                data.append("montant", this.editedItem.montant);
                data.append("phone_receiver", this.editedItem.phone_receiver);
                data.append("comment", this.editedItem.comment);
                if (this.balance) {
                    data.append("balance_now", this.balance.amount);
                }
                data.append("pharmacie_slug", user.relation._id);
                data.append("pharmacie_user_slug", user._id);
                let mineroute = 'ask_payouts/setAsk_payout';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'ask_payouts/setAsk_payout';
                }
                console.log("ELE");

                console.log(this.editedItem);
                    if (this.balance) {
                        let demande=0;

                        for (let i=0; i<this.ask_payouts.length; i++) {
                            if (this.ask_payouts[i].state_ask !=="Retrait éffectué" && this.ask_payouts[i].state_ask !=="Demande refusée" && this.ask_payouts[i].state_ask !=="Annuler"){
                                demande=demande+this.ask_payouts[i].montant
                            }
                        }

                        let demandes=parseFloat(this.editedItem.montant)+demande;
                        console.log('Demande'+demandes)

                        if (this.editedItem.montant>this.balance.amount){
                            this.snackbar = true;
                            this.textSnack = "Votre solde est insuffisant";
                            this.submitting = false;


                        }else if(demandes>this.balance.amount){
                            this.snackbar = true;
                            this.textSnack = "Vos demandes en cours et la nouvelle ne couvrent pas votre solde";
                            this.submitting = false;

                        }else if(this.editedItem.montant<10000){
                            this.snackbar = true;
                            this.textSnack = "Montant minimum de retrait insuffisant";
                            this.submitting = false;
                        }
                        else{
                            this.$store.dispatch(mineroute, data).then((response) => {
                                console.log('response', response);
                                this.snackbar = true;
                                this.textSnack = response.data.message;
                                this.submitting = false;
                                if (response.error) {
                                    this.errors.operation = response.data.message;
                                } else {
                                    this.close();
                                }
                            })

                        }
                    }else {
                        this.snackbar = true;
                        this.textSnack = "Votre solde est vide";
                        this.submitting = false;
                    }


            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>